// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"b8aa9295","706":"711ede07","726":"2b58ec26","738":"a7cef37a","991":"7a46d33e"}[chunkId] + ".chunk.js";
};